import { Option } from 'shared/components/Select/models/Option';
import { mapBuildingLiftTypesTypeLabel } from 'shared/constants/filters/mapBuildingLiftTypesTypeLabel';
import { EBuildingLiftType } from 'shared/types/filters/advanced/buildingLiftTypesType';

export const buildingLiftTypesTypeOptions = [
  new Option(EBuildingLiftType.Passenger, mapBuildingLiftTypesTypeLabel[EBuildingLiftType.Passenger]),
  new Option(EBuildingLiftType.Service, mapBuildingLiftTypesTypeLabel[EBuildingLiftType.Service]),
  new Option(EBuildingLiftType.Telpher, mapBuildingLiftTypesTypeLabel[EBuildingLiftType.Telpher]),
];
